export default __webpack_public_path__ + "static/media/warrantybox.8f92c4de.svg";